// extracted by mini-css-extract-plugin
export default {"insuranceStatus":"InsuranceStatus_insuranceStatus__e+OOQ","insured":"InsuranceStatus_insured__MkPwH","notInsured":"InsuranceStatus_notInsured__ReCKy"};